module.exports = __webpack_public_path__ + "_/_/_/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/orchestra-v2-b15cc0360b4336f82434814b6f87ac2c.svg";


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/images/icons/category-icons/orchestra-v2.svg
// module id = osk9
// module chunks = 1 3 10 12 18